export const achdata = [
    {
      id: 1,
      date: "Aug (2022)",
      position:"COE TOP Performer (FrontEnd Development)",
      company:" EPAM",
      skills:"HTML, CSS, JAVASCRIPT, REACT JS, Node JS",
      about:"",
      link:"https://www.linkedin.com/posts/mirjunaidrasool_experience-training-development-activity-6966813999027933184-Qfkc?utm_source=share&utm_medium=member_desktop",
    },
    {
        id: 2,
        date: "Mar 2 2023",
        position:"Javascript Essential Training",
        company:"Linkedin Learning",
        skills:"JAVASCRIPT",
        about:"",
        link:"https://www.linkedin.com/learning/certificates/8d04d6ed330b2f5ea6116b67ceaa39f719c36f2c72474ae80e4523fcf4293af0"
      },
      {
        id: 3,
        date: "Dec(2021)",
        position:"Google Cloud Essentials",
        company:"Google",
        skills:"Google cloud platform",
        about:"",
        link:"https://www.cloudskillsboost.google/public_profiles/5fc83c59-f822-4615-ad0b-900e63298561/badges/1585691?utm_medium=social&utm_source=linkedin&utm_campaign=ql-social-share"
      },
      {
        id: 4,
        date: "July 2021",
        position:"Google Digital Marketing",
        company:"Google",
        skills:"SEO Google Ads",
        about:"",
        link:"https://www.linkedin.com/in/mirjunaidrasool/details/certifications/"
      },
      {
        id: 5,
        date: "July 2021",
        position:"Data Science Course",
        company:"Google,Courseera",
        skills:"Data,Tableau,R,python",
        about:"",
        link:"https://www.coursera.org/account/accomplishments/certificate/4C879VSFY7UL"
      },
      {
        id: 6,
        date: "may 2022",
        position:"Git,Github and Gitlab",
        company:"Linkedin Learning",
        skills:"Git",
        about:"",
        link:"https://www.linkedin.com/learning/certificates/0600fd372caaac20995032d091b1d6010c961a7fa7ae9346e220c0de00ef665e"
      },
      {
        id: 7,
        date: "18 march 2023",
        position:"Data Visualization using SAS",
        company:"SAS Awards",
        skills:"Data visualization",
        about:"",
        link:"https://drive.google.com/file/d/1zWTu0sPUHY4Pg89E79WcfZF6sDUTMmMC/view?usp=sharing"
      },
      {
        id: 8,
        date: "1 April 2023",
        position:"Author's Workshop on Scientific Writing",
        company:"HRDC LPU",
        skills:"Scientific Writing",
        about:"",
        link:"https://drive.google.com/file/d/1T-tzSCdiKaxbt-hveGAxSum5I950U6B1/view?usp=sharing"
      },
      {
        id: 9,
        date: "june 2023",
        position:"Member of International Association of engineers",
        company:"MIAENG",
        skills:"Life Member",
        about:"",
        link:"https://drive.google.com/file/d/1Urnw1GZNS5B9jG3OzsBYsQuHoh7eViGY/view?usp=sharing"
      },
      {
        id: 10,
        date: "Jan 2019",
        position:"Recent Trends in Networks and Communication",
        company:"TQIP GNDEC",
        skills:"Networking",
        about:"",
        link:"https://drive.google.com/file/d/1X58ykn1xhSlfJ2JNmFS_BLFzVASkpENZ/view?usp=sharing"
      },
      
      {
        id: 11,
        date: "nov (2016)",
        position:"java and oracle",
        company:"Naresh IT",
        skills:"Java,Sql",
        about:"",
        link:""
      }
      

      
  ]
    